module.exports = __webpack_public_path__ + "static/google-hangouts-meet-icon-fce5cda44b1d81c696443986396dc9c0.png";